import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { AlfrescoApi } from '@alfresco/js-api';
import { Observable } from 'rxjs/Observable';
import { _throw as throwError } from 'rxjs/observable/throw';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { RamoAtividadeModel } from 'app/model/cliente/ramoatividade.model';
import { environment } from 'environments/environment';

@Injectable()
export class ClienteService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  dataCliente: any[];

  constructor(private httpClient: HttpClient) {
  }

  getTicket(): String {
    const alfrescoApi = new AlfrescoApi({
      hostEcm: 'http://localhost:5580/api'
    });
    const ticket = alfrescoApi.getTicketEcm();
    return ticket.toString();
    // console.log(ecmTicket);
  }

  // Lista de todos os clientes
  getClientes(): Observable<ResponsePageable> {

    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-cliente', this.httpOptions);
  }

  getClientesAll(): Observable<Array<ClienteModel>> {

    return this.httpClient.get<Array<ClienteModel>>(this.apiURL + '/view/listar-cliente-all', this.httpOptions);
  }

  getClienteUnico(id: any): Observable<ClienteModel> {
    return this.httpClient.get<ClienteModel> (this.apiURL + '/view/cliente-unico/' + id, this.httpOptions);
  }

  getPageClientes(page, size, nome): Observable<ResponsePageable> {
    return this.httpClient
    .get<ResponsePageable>(this.apiURL + `/view/listar-cliente?nome=${nome}&page=${page}&size=${size}`, this.httpOptions);
  }

  deleteCliente(id: any){
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/delete-cliente/' + id , {responseType: 'text', headers});
  }

  desativarCliente(cliente: ClienteModel) {
    return this.httpClient.post(this.apiURL + '/delete/desativar-cliente', cliente, this.httpOptions);
  }

  ativarCliente(cliente: ClienteModel) {
    return this.httpClient.post(this.apiURL + '/delete/ativar-cliente', cliente, this.httpOptions);
  }

  // Adicionar um novo cliente
  saveCliente(cliente: ClienteModel): Observable<ClienteModel> {
    return this.httpClient.post<ClienteModel>(this.apiURL + '/new/adicionar-cliente', cliente, this.httpOptions);
  }

  // Editar um cliente
  putCliente(cliente: ClienteModel): Observable<ClienteModel> {
    return this.httpClient.put<ClienteModel>(this.apiURL + '/edit/editar-cliente', cliente, this.httpOptions);
  }


  getTipoCliente(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-tipocliente', this.httpOptions);
  }

  getPageClientesUsuario(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/clientes-usuario', this.httpOptions);
  }

  // RAMO DE ATIVIDADE
  getRamoAtividade(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-ramo', this.httpOptions);
  }

  getPageRamoAtividade(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-ramo?page=${page}&size=${size}`, this.httpOptions);
  }

  getPageRamoAtividadeList(): Observable<RamoAtividadeModel[]> {
    return this.httpClient.get<RamoAtividadeModel[]>(this.apiURL + `/view/list/listar-ramo`, this.httpOptions);
  }

  getProdutosPorIdCliente(id: any): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + '/view/' + id + '/produtos', this.httpOptions);
  }

  // AREA
  getArea(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-areas', this.httpOptions);
  }

  postRamo(ramoAtividade: RamoAtividadeModel): Observable<RamoAtividadeModel>{
    return this.httpClient.post<RamoAtividadeModel>(this.apiURL + '/new/adicionar-ramo', ramoAtividade, this.httpOptions);
  }

  putRamo(ramoAtividade: RamoAtividadeModel): Observable<RamoAtividadeModel> {
    return this.httpClient.put<RamoAtividadeModel>(this.apiURL + '/edit/editar-ramo', ramoAtividade, this.httpOptions);
  }

  deleteRamo(id: any) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/delete-ramo/' + id, { responseType: 'text', headers });
  }

  putIndiceReajuste(ramoAtividade: RamoAtividadeModel): Observable<RamoAtividadeModel>{
    return this.httpClient.put<RamoAtividadeModel>(this.apiURL + '/edit/editar-ramo', ramoAtividade, this.httpOptions);
  }

  getGrupoCliente(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-grupocliente', this.httpOptions);
  }

  getIndiceReajuste(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-indice', this.httpOptions);
  }

  getTipoReajuste(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-tiporeajuste', this.httpOptions);
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
      console.log('errorMessage1if: '+ errorMessage);
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;
      console.log('errorMessage2if: '+ errorMessage);
    }
    console.log('errorMessage' + errorMessage);
    return throwError(errorMessage);
  };

  nomeCliente(id): Observable<String> {
    return this.httpClient.get<String>(this.apiURL + `/nome-cliente/${id}`, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/cliente.service.ts